import { useEmptyFeed } from '@confluence/feed/entry-points/useEmptyFeed.ts';

export const usePostOfficeHomeBannerEligible = (): {
	isEligible: boolean;
} => {
	const { hasFeed } = useEmptyFeed();

	return {
		isEligible: hasFeed,
	};
};
